import { takeLatest, call, put } from 'redux-saga/effects';
import * as jobTitleActions from 'redux/ducks/JobTitle/JobTitleDucks';
import employeeApi from 'api/employee/employeeApi';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* createJobTitle({ payload }) {
  try {
    const response = yield call(employeeApi.createTitle, payload);
    yield put(jobTitleActions.createJobTitleSuccess(response));
    yield put(jobTitleActions.updateJobTitleList(payload));
  } catch (error) {
    yield put(jobTitleActions.createJobTitleFail(error));
    // MB648 중복 코드 일경우 메세지 말고 에러메세지로 팝업에 뿌려주기
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* deleteJobTitle({ payload }) {
  try {
    const response = yield call(employeeApi.deleteTitle, payload);
    yield put(jobTitleActions.deleteJobTitleSuccesse(response));
    yield put(jobTitleActions.removeJobTitleList(payload));
  } catch (error) {
    yield put(jobTitleActions.deleteJobTitleFail(error));
    // MB648 중복 코드 일경우 메세지 말고 에러메세지로 팝업에 뿌려주기
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export default function* JobTitleSaga() {
  yield takeLatest(jobTitleActions.createJobTitle, createJobTitle);
  yield takeLatest(jobTitleActions.deleteJobTitle, deleteJobTitle);
}
